import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface TurnsLinkProps {
	turns: number
}

export function TurnsLink(props: TurnsLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('turns', `${props.turns}`)
		}}>
			{props.turns}
		</a>
	)
}
